import React from 'react';
import '../../components/Layout.css';

export const POPULATIONS = [
  { value: 'organic', label: 'Organic signups' },
  { value: 'engaged', label: 'Ever logged in' },
  { value: 'all', label: 'All accounts' },
];

/**
 * Chrome shared by every behavior report.
 *
 * The denominator line is not decoration. The old reports were untrusted
 * because every number was unfalsifiable - the same metric reads 1.8% or 6.2%
 * depending on a population nobody was choosing consciously. Stating it in
 * words, next to a control that changes it, is the fix.
 */
export default function ReportShell({
  title,
  headline,
  population,
  onPopulationChange,
  showPopulation = true,   // false where population is not a real dimension
  populationSize,
  populationNoun = 'athletes',
  thin,
  thinLabel = 'Not enough data yet to read these as rates.',
  loading,
  error,
  children,
}) {
  return (
    <section className="report-section">
      <header className="report-header">
        <h2>{title}</h2>
        {showPopulation && (
          <label className="report-population">
            Population:{' '}
            <select value={population} onChange={(e) => onPopulationChange(e.target.value)}>
              {POPULATIONS.map((p) => (
                <option key={p.value} value={p.value}>{p.label}</option>
              ))}
            </select>
          </label>
        )}
      </header>

      {loading && <p className="report-loading">Loading…</p>}
      {error && <p className="report-error">{error}</p>}

      {!loading && !error && (
        <>
          {headline && <p className="report-headline">{headline}</p>}
          <p className="report-denominator">
            Measured across {populationSize} {populationNoun}.
          </p>
          {thin && <p className="report-thin">{thinLabel}</p>}
          {children}
        </>
      )}
    </section>
  );
}
